import { render, staticRenderFns } from "./RegistraPezziSeriali.vue?vue&type=template&id=b87e7646&scoped=true&"
import script from "./RegistraPezziSeriali.vue?vue&type=script&lang=js&"
export * from "./RegistraPezziSeriali.vue?vue&type=script&lang=js&"
import style0 from "./RegistraPezziSeriali.vue?vue&type=style&index=0&id=b87e7646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87e7646",
  null
  
)

export default component.exports